import { createTheme } from '@mui/material/styles';

export default createTheme({
    palette: {
      primary: {
        main: '#f7af14',
      },
      secondary: {
        main: '#8a8a8a',
      },
      info: {
        main: '#00afef',
      },
      text: {
        main: '#ffffff'
      },
      warning: {
        main: '#fc0303'
      }
    },
});